import { jsx } from "react/jsx-runtime";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { validateTidalLicense } from "../../base/index.js";
function ExpandLess(props) {
  return /* @__PURE__ */ jsx(
    ExpandLessIcon,
    {
      "data-testid": "ExpandLess",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ExpandLess",
      "data-tidal-icon-meta": "arrows"
    }
  );
}
ExpandLess.tidalIconMeta = {
  categories: "arrows",
  name: "ExpandLess"
};
validateTidalLicense();
export {
  ExpandLess
};
//# sourceMappingURL=ExpandLess.js.map
